import React from 'react'
import { useTranslation } from 'react-i18next'

interface StatusCellProps {
  status: 'paid' | 'pending' | 'rejected'
}

export const StatusCell = ({ status }: StatusCellProps) => {
  const { t } = useTranslation()

  return (
    <span
      className={`rounded-[6px] py-[2px] px-[8px] text-[10px] font-semibold uppercase ${
        {
          paid: 'bg-success-300 text-success-400',
          pending: 'bg-aqua-300/[.07] text-aqua-300',
          rejected: 'bg-danger/[.07] text-[#DA5533]',
        }[status]
      }`}
    >
      {t(`pages.referralProgram.status.${status}`)}
    </span>
  )
}
